// extracted by mini-css-extract-plugin
module.exports = {"content":"index_content__c9y8E"};